"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AuthInterceptor {
    constructor(requestAuthenticator, logger) {
        this.intercept = async (request) => {
            this.logger.log(`Authenticating request to ${request.url}`);
            return this.requestAuthenticator.authenticate(request, await this.tokenService.getValidToken());
        };
        this.requestAuthenticator = requestAuthenticator;
        this.logger = logger;
    }
    setTokenService(tokenService) {
        this.tokenService = tokenService;
    }
}
exports.default = AuthInterceptor;
//# sourceMappingURL=AuthInterceptor.js.map